module.exports = __webpack_public_path__ + "assets/roboto-light.528b0bf4a9a3040e6a8cc8a7388de437552601901fcc9caad198c3c5f954de10.woff2";